<template>
  <div />
</template>
<script>
import maintenance from './global/maintenance'
import message from './global/message'

export default {
  mounted () {
    this.$echo
      .channel('System')
      .listen('SystemBroadcast', (e) => {
        const type = e.type
        const payload = e.payload || []
        switch (type) {
          case 'maintenance':
            maintenance(payload)
            break
          case 'message':
            message(payload)
            break
        }
      })
  },
  beforeUnmount () {
    this.$echo.leave('System')
  }
}
</script>
